import "../../../utils/messages";
import { TEAM_MESSAGES } from "../../../utils/messages";
import { ClientMessage } from "../../../utils/objects";

export function assignTeamRequests(api) {
    /****************************************TEAMS*********************************************************/
    let teamsBaseURL = "/enterprise/teams";
    api.getTeams = async function () {
        var response = await api.get(teamsBaseURL, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TEAM_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getTeam = async function (idTeam) {
        var response = await api.get(teamsBaseURL + '/' + idTeam, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TEAM_MESSAGES.NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.createTeam = async function (team) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.CREATED, [team.name]);

        var response = await api.post(
            teamsBaseURL,
            JSON.stringify(team),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, TEAM_MESSAGES.NOT_CREATED, [team.name]);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    api.editTeam = async function (team) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.MODIFIED, [team.name]);

        var response = await api.put(
            teamsBaseURL,
            JSON.stringify(team),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, TEAM_MESSAGES.NOT_MODIFIED, [team.name]);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    api.deleteTeam = async function (idTeam, teamName) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.DELETED, [teamName]);

        var response = await api.delete(teamsBaseURL + '/' + idTeam, this.buildConfig())
            .then(res => res.status != 400)
            .catch(e => {
                clientMessage = this.checkError(e, TEAM_MESSAGES.NOT_DELETED, [teamName]);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    api.addTeamMember = async function (idTeam, member) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.MEMBER_ADDED);

        var response = await api.post(
            teamsBaseURL + "/" + idTeam + '/members',
            JSON.stringify(member),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, TEAM_MESSAGES.MEMBER_NOT_ADDED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    api.removeTeamMember = async function (idTeam, idUser) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.MEMBER_REMOVED);

        var response = await api.delete(teamsBaseURL + '/' + idTeam + '/members/' + idUser, this.buildConfig())
            .then(res => res.status != 400)
            .catch(e => {
                clientMessage = this.checkError(e, TEAM_MESSAGES.MEMBER_NOT_REMOVED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    // Assegna i gruppi rubrica gestiti dal team. Body atteso dal server: { ids_groups: ["<uuid>", ...] }.
    // L'endpoint mantiene il nome storico /assign-hosts; il modello v2 (team_groups) accetta solo gruppi.
    api.assignHostsToTeam = async function (idTeam, idsGroups) {
        var clientMessage = ClientMessage.success(TEAM_MESSAGES.HOSTS_ASSIGNED);
        var body = { ids_groups: Array.isArray(idsGroups) ? idsGroups : [] };

        var response = await api.post(
            teamsBaseURL + '/' + idTeam + '/assign-hosts',
            JSON.stringify(body),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, TEAM_MESSAGES.HOSTS_NOT_ASSIGNED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "teammethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildTeamMap();

        return response;
    }

    api.getTeamsForOperator = async function (idUser) {
        var response = await api.get(teamsBaseURL + '/for-operator/' + idUser, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TEAM_MESSAGES.OPERATOR_TEAMS_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getTeamsWithIdCustomer = async function(idCustomer){
        var response = await api.get(teamsBaseURL + "/customer/" + idCustomer, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TEAM_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    
}